<template>
    <div class="apn-page apn-partners">
        <!-- Banner -->
        <apn-banner :bg-image="BannerImg" :message="message" />
        <!-- Main -->
        <section class="section">
            <p class="apn-message">{{$t('partners.offer')}}</p>
            <p class="apn-message">
                Below are some of the projects that are currently powered by MyanmarAPN and many more projects already 
                joined our movement “Towards a faster nation”!
            </p>
        </section>
        <section class="section section--partners">
            <div class="apn-container">
                <h1>our recent projects</h1>
                <div class="partners">
                    <div class="partner" 
                        v-for="project in projects" :key="project.id"
                        :style="{'background-image': `url(${env.imageUrl + project.logo})`}">
                        <div class="layer">
                            <h3>{{project.name}}</h3>
                        </div>
                    </div>
                </div>
                <div v-show="loading">
                    <div class="lds-css ng-scope">
                        <div style="width:100%;height:100%" class="lds-ellipsis">
                            <div><div></div></div>
                            <div><div></div></div>
                            <div><div></div></div>
                            <div><div></div></div>
                            <div><div></div></div>
                        </div>
                    </div>
                </div>
                <button class="apn-btn--more" v-show="more" @click="getProjects">more</button>
            </div>
        </section>
        <section class="apn-container apn-contact-us">
            <h2>be our partner</h2>
            <p>
                <router-link style="color:#00aeef" to="/contact">Contact us</router-link> 
                find out more or how we can help you better.</p>
        </section>
        <div style="width: 100%; height: 40px;"></div>
        <!-- Contact Form -->
        <!-- <apn-contact-form /> -->
        <!-- Footer -->
        <apn-footer />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import ApnBanner from '@/components/ApnBanner'
import ApnFooter from '@/components/ApnFooter'
import ApnContactForm from '@/components/ApnContact'
import BannerImg from '@/assets/images/partners-banner.jpg'
import env from '@/enviorments'

// import { projectss } from '@/assets/projects'
import { setTimeout, clearTimeout } from 'timers';

export default {
    name: 'ApnPartners',
    components: {
        ApnBanner,
        ApnFooter,
        ApnContactForm,
    },
    data() {
        return {
            BannerImg,
            message: {
                header: 'Join our\n"Towards a Faster Nation"\nMoment',
                content: 'partners.info',
            },
            env,
        }
    },
    computed: {
        ...mapState({
            projects: state => state.projects,
            more: state => state.more,
            loading: state => state.loading,
        })
    },
    methods: {
        ...mapActions({
            getDefaultProjects: 'getDefaultProjects',
            getProjects: 'getProjects',
        }),
    },
    mounted() {
        if (!this.projects) this.getDefaultProjects()
    }
}
</script>

<style lang="scss" scoped>
.apn-partners {
    .section {
        padding: 40px 0;
        .apn-message {
            margin: 10px auto;
            padding: 0 20px;
            max-width: 700px;
            text-align: center;
            font-size: 16px;
        }
    }
    .section--partners {
        background-color: var(--theme-bg);
        .apn-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            h1 {
                text-transform: uppercase;
                font-size: 42px;
                font-weight: 300;
                text-align: center;
                padding: 40px 0 20px;
                color: var(--primary);
                @media (min-width: 992px) {
                    font-size: 54px;
                }
            }
            .partners {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: flex-start;
                padding: 20px 0;
                .partner {
                    width: calc(100% - 30px);
                    height: 200px;
                    background-color: #eee;
                    margin: 15px;
                    max-width: 400px;
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    position: relative;
                    overflow: hidden;
                    animation: Show .2s ease;
                    @media (min-width: 768px) {
                        width: calc(50% - 30px);
                    }
                    @media (min-width: 992px) {
                        width: calc(33.33% - 30px);
                    }
                    .layer {
                        position: absolute;
                        top: 60%; right: 0; bottom: 0; left: 0;
                        background-color: #63c2e1ee;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        text-align: right;
                        @media (min-width: 768px) {
                            transform: translate(0, 100%);
                            transition: .2s ease-out;
                        }
                        h3 {
                            font-size: 24px;
                            font-weight: 600;
                            margin: 0;
                            padding: 0 20px;
                            color: #fff;
                        }
                    }
                    &:hover .layer {
                        transform: translate(0, 0);
                    }
                }
            }
            .apn-btn--more {
                margin: 20px auto;
            }
        }
    }
    .apn-contact-us {
        padding: 40px 20px 0;
        max-width: 900px;
        h2 {
            text-transform: uppercase;
            font-size: 20px;
        }
        p {
            padding: 0;
        }
    }
    @keyframes Show {
        from {
            height: 0px;
        }
        to {
            height: 200px;
        }
    }
}
</style>

